import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { I18nService } from '@localize/services/';
import { ConfirmDialogComponent, PlainDialogComponent } from '@services/feedback/dialogs/';

import { FeedbackData, FeedbackStyle, FeedbackTitle, NotificationData } from './_models';

export * from './_models';

/**
 * service to manage alert, confirm etc. dialogs
 */

@Injectable({
	providedIn: 'root'
})
export class FeedbackService {
	constructor(public dialog: MatDialog, private i18nService: I18nService, private snackBar: MatSnackBar) {}

	public notification(data: NotificationData) {
		this.snackBar.open(data.msg, data.action ? data.action : 'x', data.config ? data.config : { duration: 2000 });
	}

	public plain(data: FeedbackData): void {
		const dialogConfig = new MatDialogConfig();

		dialogConfig.autoFocus = true;

		data = this.interceptDefaultTitle(data);
		dialogConfig.data = data;

		this.dialog.open(PlainDialogComponent, dialogConfig);
	}

	public input(data: FeedbackData): void {
		const dialogConfig = new MatDialogConfig();

		dialogConfig.autoFocus = true;

		data = this.interceptDefaultTitle(data);
		dialogConfig.data = data;

		this.dialog.open(ConfirmDialogComponent, dialogConfig);
	}

	public confirm(data: FeedbackData): void {
		const dialogConfig = new MatDialogConfig();

		data = this.interceptDefaultTitle(data);
		dialogConfig.data = data;

		this.dialog.open(ConfirmDialogComponent, dialogConfig);
	}

	public apiError(error: any, message?: string, contentClass?: string) {
		const data: FeedbackData = {
			title: FeedbackTitle.attention,
			message:
				message ||
				error?.error?.errorMessage ||
				this.i18nService.get('Oops! Something went wrong.', 'app.api.response.general-request-error'),
			style: FeedbackStyle.error,
			contentClass: contentClass ? contentClass : ''
		};
		this.plain(data);
	}

	/**
	 * intercept default feedback title
	 * and retrieve i18n string
	 */
	private interceptDefaultTitle(data: FeedbackData): FeedbackData {
		// find i18n string for title, if exist
		const isEnum: FeedbackTitle | undefined = FeedbackTitle[data.title];
		if (isEnum !== undefined) {
			data.title = this.i18nService.get('Error', 'app.descriptor.' + data.title);
		}
		return data;
	}
}
